import { Fancybox } from '@fancyapps/ui/dist/fancybox/';
import Splide from '@splidejs/splide';
import { unitlessBreakpoints } from '../helpers/breakpoints';

const TRIGGER = '[data-dynamic-gallery-trigger]';
const CAROUSEL = '[data-splide-carousel]';

function imageSrcForFancybox(img) {
  if (!img) {
    return '';
  }
  let src = img.src || img.dataset.src || '';

  if (img.srcset) {
    const srcsetParts = img.srcset.split(',');
    const largest = srcsetParts[srcsetParts.length - 1].trim().split(' ')[0];

    src = largest || src;
  }

  return src;
}

export default class DynamicGallery {
  constructor(section) {
    this.el = section.el;
    this.carouselEl = this.el.querySelector(CAROUSEL);
    this._onClick = this._onClick.bind(this);
    this._onImgLoad = this._onImgLoad.bind(this);
    this.el.addEventListener('click', this._onClick);

    this.splide = null;

    if (this.carouselEl) {
      // Do not use initCarousel(): it mutates splide.options after mount and can wipe
      // autoWidth. Mount Splide directly (same idea as DynamicSlideshow).
      this.splide = new Splide(this.carouselEl, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: 0,
        arrows: true,
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.md]: {
            autoWidth: true,
            height: '37.5rem',
            gap: '1.25rem',
          },
        },
      });

      this.splide.mount();

      // autoWidth measures slide widths; refresh when images finish loading.
      this.carouselEl.querySelectorAll('img').forEach(img => {
        if (img.complete) {
          return;
        }
        img.addEventListener('load', this._onImgLoad, { once: true });
      });
    }
  }

  _onImgLoad() {
    if (this.splide) {
      this.splide.refresh();
    }
  }

  _onClick(event) {
    const trigger = event.target.closest(TRIGGER);
    if (!trigger || !this.el.contains(trigger)) {
      return;
    }
    event.preventDefault();

    if (!this.carouselEl) {
      return;
    }

    const slides = this.carouselEl.querySelectorAll('.splide__slide');
    const fancyboxItems = [];

    slides.forEach(slide => {
      const slideTrigger = slide.querySelector(TRIGGER);
      const img = slide.querySelector('img');
      if (!slideTrigger || !img) {
        return;
      }

      const src = imageSrcForFancybox(img);
      if (!src) {
        return;
      }

      const caption =
        slideTrigger.getAttribute('data-caption') ||
        img.getAttribute('data-caption') ||
        img.alt ||
        '';

      fancyboxItems.push({
        src,
        caption,
      });
    });

    if (fancyboxItems.length === 0) {
      return;
    }

    const slideEl = trigger.closest('.splide__slide');
    const startIndex = slideEl ? [...slides].indexOf(slideEl) : 0;

    Fancybox.show(fancyboxItems, {
      startIndex: Math.max(0, startIndex),
      Carousel: {
        Thumbs: false,
      },
    });
  }

  onSectionUnload() {
    this.el.removeEventListener('click', this._onClick);
    if (this.carouselEl) {
      this.carouselEl.querySelectorAll('img').forEach(img => {
        img.removeEventListener('load', this._onImgLoad);
      });
    }
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
